import React, { Component } from 'react'
import { MDBContainer, MDBAlert,  MDBTable, MDBTableBody, MDBTableHead, MDBBtn, MDBIcon,MDBTypography } from 'mdbreact';
import Axios from 'axios'
import { Alert, Form, Input, Button, Select, Icon, message, Tag, Badge, Tooltip,PageHeader  } from 'antd';

import adminfaculty from '../adminfaculty/adminfaculty';
import Modalexpert from './Modalexpert';
import Modalexpertbn from './Modalexpertbn';
import Commentbnlist from './Commentbnlist';
import Commentbnlistfromex from './Commentbnlistfromex';

//import Modalarticletyps from './Modalarticletypes';+
import { URL,api } from '../../api';
import Modaladdexpert from '../superadmin/Modaladdexpert';
import Modalarticleaddexpert from '../superadmin/Modalarticleaddexpert';
import Modalsentpassbn from '../adminfaculty/Modalsentpassbn';
import Modalsentpassforbn from '../adminfaculty/Modalsentpassforbn';
import Commentexlistforadmin from './Commentexlistforadmin';
import Modalsentpassforex from '../adminfaculty/Modalsentpassforex';
import Modaleditstatuspsf from '../superadmin/Modaleditstatuspsf';
import Commentexchecklistpsf from './Commentexchecklistpsf';
import Loadding from './Loadding';
//import Modalexpercommentscoreshow from './Modalexpercommentscoreshow';





var Latex = require('react-latex');





export default class expertexpsfsuccess extends Component {

    constructor(props) {
        super(props);
        this.state = {
            article:[],
            articleex:[],
            extertype:'',
            expert_id:'',
            loadding: false,
            url:'https://mua.kpru.ac.th/FrontEnd_Kprupsf/',
           //  url:'https://git.kpru.ac.th/FrontEnd_Kprupsf/',
        };
        // this.handleChange = this.handleChange.bind(this);
        // this.handleChange2 = this.handleChange2.bind(this);
         this.updateat = this.updateat.bind(this);
         this.selectex = this.selectex.bind(this);
         this.dow = this.dow.bind(this);
         this.extertype = this.extertype.bind(this);
         
      }


    componentDidMount() {

       this.setState({ loadding: true })

      setTimeout(() => {
       // api.get('registercon/selectArticleforexpertbn/'+localStorage.getItem('iduser') )
       api.get('registercon/SelectArticleforexcheckpsfsuccess/'+localStorage.getItem('iduser'))
           .then(res => {
         //    console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ loadding: false })
             this.setState({ article: res.data})
             this.setState({ expert_id: localStorage.getItem('iduser')})
           }) 
       }, 0);

         


      setTimeout(() => {
         //   Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpertatex.php?idexpert='+localStorage.getItem('expert_id') )
         //  .then(res => {
         //    console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
          //   this.setState({ articleex: res.data})
             //this.setState({ expert_id: localStorage.getItem('expert_id')})
         //  }) 

         }, 0);

       
      //  this.extertype();
      }

      updateat(){
        setTimeout(() => {
           
          api.get('registercon/selectArticleforexpertbnandadmin/'+localStorage.getItem('presentype_id') )
          .then(res => {
        //    console.log(res);
          //  this.setState({ bankname: res.data, loading: false })
            this.setState({ article: res.data})
            this.setState({ expert_id: localStorage.getItem('iduser')})
          }) 
      }, 0);
      
      }



      selectex() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
        }
        setTimeout(() => {
           
            Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpertatbn.php?idexpert='+localStorage.getItem('expert_id') )
           .then(res => {
          //   console.log(res);
           //  this.setState({ bankname: res.data, loading: false })
             this.setState({ article: res.data})
           }) 

         }, 0);



      }

      extertype() {

        // const token = JSON.parse(localStorage.getItem('nameuser'));
        if (localStorage.getItem('nameuser') == null) {
            window.location.href = '/'
        } else {
        }
        setTimeout(() => {
           
            Axios.get('https://conference.kpru.ac.th/PHPAPI/selectExpertattype.php?idexpert='+localStorage.getItem('expert_id') )
           .then(res => {
          //   console.log(res.data[0].expert_type);
           //  this.setState({ bankname: res.data, loading: false })
        //     this.setState({ extertype: res.data[0].expert_type})
           }) 

         }, 0);



      }

      

      dow(){
       
           
          if (localStorage.getItem('expert_id') !== null) {

              if (this.state.extertype === '1') {
                 window.open(
                    'https://conference.kpru.ac.th/PHPAPI/TCPDF-main/invite.php?expert_id='+localStorage.getItem('expert_id') ,
                    '_blank' // <- This is what makes it open in a new window.
                  );
              }else{
                window.open(
                  'https://conference.kpru.ac.th/PHPAPI/TCPDF-main/invite2.php?expert_id='+localStorage.getItem('expert_id') ,
                  '_blank' // <- This is what makes it open in a new window.
                );

              }

           // window.location.href = 'https://conference.kpru.ac.th/PHPAPI/TCPDF-main/invite.php?expert_id='+localStorage.getItem('expert_id') 
           

        } else {
        }
      }



    render() {
      console.log(this.state.expert_id)
        return (
            <MDBContainer fluid>
            <div>
            <p className="text-right">สวัสดีคุณ : {localStorage.getItem('nameuser')} (คณะกรรมการ)</p>
        


               {/* <MDBAlert color="success" >
                   <h2><MDBIcon icon="book-open" className="green-text pr-3" /> บทความเข้าใหม่</h2>
                </MDBAlert> */}
                <MDBAlert color="secondary" >
                                    <PageHeader
                                    className="site-page-header"
                                // onBack={() => null}
                                    title="ประวัติการตรวจผลงาน"
                                    subTitle="ประวัติการตรวจผลงาน ที่มีสถานะ ผ่าน(4) ไม่ผ่าน(0) ไม่พิจารณา(3) (สำหรับคณะกรรมการตรวจผลงาน)"
                                    avatar={{ src: 'https://cdn-icons-png.flaticon.com/512/4514/4514882.png' }}
                                />
                </MDBAlert>    

           
                <h3>
               
            </h3>

            {this.state.loadding === true ?<>
            <Loadding/>
            <br/>
            </>:<>

                <MDBTable bordered responsive striped>
                    <MDBTableHead color="stylish-color" textWhite>
                        <tr>
                        <th>ลำดับ</th>
                        <th >ชื่อเรื่อง</th>
                        <th >ผู้ส่ง</th>
                        <th >วันที่ส่ง</th>
                        <th >จัดการสถานะ</th>
                        
                        {/* <th>ประเภท</th>
                        <th>สถานะ</th> */}
                        {/* <th>จัดการผู้ทรงคุณวุฒิ </th> */}
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.article.map((article,index )  => 
                     <tr>

                            <td>{index+1}</td>
                            <td><span className="font-weight-bold">ผลงาน :</span>  <span className="teal-text font-weight-bold">  ผลงาน KPRU PSF</span> 
                            
                            {/* <MDBTypography note noteColor='primary' noteTitle='ส่วนที่ 1 เจ้าหน้าที่'> </MDBTypography>
                            <Commentbnlist id_send={article.id_send} expert_id={this.state.expert_id} />
                            {article.bn_comment != '2' ?<>
                            
                            </>:<></>}
                            
                            <MDBTypography note noteColor='secondary' noteTitle='ส่วนที่ 2 ส่วนผู้ทรงคุณวุฒิ'> </MDBTypography>
                            <Commentexlistforadmin id_send={article.id_send}  /> 
                            {article.ex_comment != '2'  ?<>
                            {article.stapat !==	null?<>
                            
                            </>:<></>}
                            
                            </>:<></>} */}
                            {/* <Modalarticleaddexpert id_send={article.id_send} name_article={article.name_article}  expert_id={localStorage.getItem('iduser')} bn_comment={article.bn_comment}	 /> */}
                            </td>
                             <td> <span className="teal-text font-weight-bold">{article.nameuser	}</span></td>
                              <td><span className="teal-text font-weight-bold">{article.dateadd	}</span></td>
                             <td> <Commentexchecklistpsf id_emp={article.id_emp} id_articlepsf={article.id_articlepsf} typelevel={article.typelevel} expert_id={this.state.expert_id}  /></td>

                            {/* <td>
                                <a href={`${this.state.url+article.send_uploadeword}`}  target="_blank"><p className="blue-text"><MDBIcon far icon="file-word" /> word</p> </a>
                              
                              </td>
                             <td>
                              <a href={`${this.state.url+article.send_uploadepdf}`}  target="_blank"><p className="red-text"><MDBIcon far icon="file-pdf" /> pdf</p> </a>
                              
                               </td> */}

                             {/* <td> <Modaleditstatuspsf nameuser={article.nameuser} /> </td>
                           */}
                            
                         
                     </tr>
                    

                      )}
                    </MDBTableBody>
                    </MDBTable>

                 <hr/>
</>}
                {/* <MDBAlert color="success" >
                   <h2><MDBIcon icon="book-open" className="green-text pr-3" /> บทความหลังผู้ทรงตรวจ</h2>
                </MDBAlert>
                <MDBTable bordered>
                    <MDBTableHead color="stylish-color" textWhite>
                        <tr>
                        <th>ลำดับ</th>
                        <th>ชื่อเรื่อง</th>
                        <th>สาขา</th>
                        <th>ไฟล์บทความสำหรับตรวจ</th>
                       
                        </tr>
                    </MDBTableHead>

                    <MDBTableBody>
                    {this.state.articleex.map((articleex,index )  => 
                        <tr>
                        <td>{index+1}</td>
                        <td>{articleex.send_name}</td>
                        <td>{articleex.major_precent}</td>
                        <td>
                           
                            <Commentbnlistfromex id_send={articleex.id_send} expert_id={this.state.expert_id}  />
                             </td>
                         <td>
                             
                             </td>
                        </tr>
                      )}
                    </MDBTableBody>
                    </MDBTable> */}

            </div>
            </MDBContainer>
        )
    }
}
